import { Module } from 'vuex'

export interface Testimonial {
  id: number
  name: string
  location: string
  rating: number
  message: string
  date: string
  approved: boolean
}

export interface TestimonialsState {
  items: Testimonial[]
}

const STORAGE_KEY = 'hsb_testimonials'

const SEED: Testimonial[] = [
  {
    id: 1,
    name: 'Amina Uwase',
    location: 'Kigali, Gasabo',
    rating: 5,
    message: 'The food is absolutely amazing! Isombe tasted exactly like what my mum used to cook. Fresh, warm, and delivered on time. I order every day now!',
    date: '2026-03-10',
    approved: true
  },
  {
    id: 2,
    name: 'Jean-Paul Habimana',
    location: 'Kigali, Kicukiro',
    rating: 5,
    message: 'Best delivery service in Kigali. The grilled chicken is always perfectly cooked and the portions are generous. Highly recommend!',
    date: '2026-03-12',
    approved: true
  },
  {
    id: 3,
    name: 'Claudine Mukamana',
    location: 'Kigali, Nyarugenge',
    rating: 5,
    message: 'HomeSweet Bites saved my lunch breaks. Real home food at the office — no more sad canteen meals. The beef stew with potatoes is my favourite!',
    date: '2026-03-15',
    approved: true
  },
  {
    id: 4,
    name: 'Eric Nshimiyimana',
    location: 'Kigali, Remera',
    rating: 4,
    message: 'Very tasty and affordable. I love that the menu changes daily so there is always something new to try. Keep it up!',
    date: '2026-03-18',
    approved: true
  }
]

function load (): Testimonial[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : SEED
  } catch { return SEED }
}

function save (items: Testimonial[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
}

const testimonials: Module<TestimonialsState, unknown> = {
  namespaced: true,
  state: () => ({ items: load() }),
  getters: {
    approved: (s) => s.items.filter(t => t.approved).sort((a, b) => b.date.localeCompare(a.date)),
    pending: (s) => s.items.filter(t => !t.approved).sort((a, b) => b.date.localeCompare(a.date)),
    all: (s) => [...s.items].sort((a, b) => b.date.localeCompare(a.date))
  },
  mutations: {
    ADD (state, t: Testimonial) {
      const next = [t, ...state.items]
      state.items = next
      save(next)
    },
    APPROVE (state, id: number) {
      const idx = state.items.findIndex(t => t.id === id)
      if (idx !== -1) {
        const next = [...state.items]
        next[idx] = { ...next[idx], approved: true }
        state.items = next
        save(next)
      }
    },
    REJECT (state, id: number) {
      const next = state.items.filter(t => t.id !== id)
      state.items = next
      save(next)
    }
  },
  actions: {
    submit ({ commit, state }, payload: Omit<Testimonial, 'id' | 'approved' | 'date'>) {
      const id = Math.max(0, ...state.items.map(t => t.id)) + 1
      const t: Testimonial = {
        ...payload,
        id,
        approved: false,
        date: new Date().toISOString().split('T')[0]
      }
      commit('ADD', t)
    },
    approve ({ commit }, id: number) { commit('APPROVE', id) },
    reject ({ commit }, id: number) { commit('REJECT', id) }
  }
}

export default testimonials
